export const WS_GENERIC_URL = '/ws/generic/'
